export enum AsyncStatus {
    Initial = 'Initial',
    Loading = 'Loading',
    Success = 'Success',
    Error = 'Error',
};